var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { FileUploaderContainer, Title } from './elements';
import { ImagePreview } from './ImagePreview';
import { FileUploadButton } from './FileUploadButton';
import { isComponentType, attachSubComponents } from '../../util';
var filterOutUploadButton = function (children) {
    return children.filter(function (el) { return !isComponentType(el, FileUploadButton); });
};
export var FileUploader = attachSubComponents('FileUploader', forwardRef(function (_a, fRef) {
    var children = _a.children, props = __rest(_a, ["children"]);
    // handle the case when children is not an array
    children = [children].flat();
    var hasImage = children.find(function (el) {
        return isComponentType(el, ImagePreview) &&
            el.props.imageSrc;
    });
    if (hasImage) {
        children = filterOutUploadButton(children);
    }
    return (React.createElement(FileUploaderContainer, __assign({}, props, { ref: fRef }), children));
}), { Title: Title, ImagePreview: ImagePreview, FileUploadButton: FileUploadButton });
